import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowRightFromBracket, faUserSecret } from '@fortawesome/pro-light-svg-icons';
import { AssumeSessionService } from '../../services/assume-session.service';

/**
 * Compact in-nav indicator + return button shown whenever an admin is signed
 * in as another user. Renders nothing when there's no active assume session.
 */
@Component({
  selector: 'app-assume-banner',
  standalone: true,
  imports: [FontAwesomeModule],
  templateUrl: './assume-banner.component.html',
  styleUrl: './assume-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssumeBannerComponent {
  protected assumeSession = inject(AssumeSessionService);

  icons = {
    secret: faUserSecret,
    exit: faArrowRightFromBracket,
  };

  async end(): Promise<void> {
    await this.assumeSession.end(this.assumeSession.isExpired() ? 'inactive' : 'manual');
  }

  stay(): void {
    this.assumeSession.extendInactivity();
  }
}
